<dialogContent>
  <div
    class="confirmation-dialog__text"
    [innerHTML]="confirmationDialogData.text | transloco: confirmationDialogData.textParams | sanitizeHtml"></div>

  @if (confirmationDialogData.warningText) {
    <tt-banner [message]="confirmationDialogData.warningText | transloco" [type]="'warning'" />
  }
</dialogContent>

<dialogActions>
  <button data-testid="confirmation-dialog_cancel-button" ttButton variant="secondary" (click)="handleCancel()">
    <span>{{ confirmationDialogData.cancelButton ?? 'Cancel' | transloco }}</span>
  </button>

  @if (confirmationDialogData.confirmButton) {
    <button data-testid="confirmation-dialog_confirm-button" ttButton variant="primary" (click)="handleConfirm()">
      <span>{{ confirmationDialogData.confirmButton | transloco }}</span>
    </button>
  }
</dialogActions>
